<kt-portlet [ngClass]="'kt-portlet--ngviewer'">
    <kt-portlet-header [title]="'Gráfico estatístico de filtro ' ">

        <ng-container ktPortletTools>

            <button mat-icon-button matTooltip="Exportar Excel" (click)="exportToExcel()">
                <i class="la la-download more-size"></i>
            </button>

            <mat-button-toggle-group #group="matButtonToggleGroup" [(value)]="_sort" (change)="changeSort($event)">
                <mat-button-toggle value="alphabetic" aria-label="Text align left">
                    <i class="la la-sort-numeric-asc more-size"></i>
                </mat-button-toggle>

                <mat-button-toggle value="asc" aria-label="Text align left">
                    <i class="la la-sort-amount-asc more-size"></i>
                </mat-button-toggle>
                <mat-button-toggle value="desc" aria-label="Text align center">
                    <i class="la la-sort-amount-desc more-size"></i>
                </mat-button-toggle>

            </mat-button-toggle-group>

        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>

        <div class="row">

            <div *ngIf="_rangeOptions!=null && _rangeOptions.length > 1" class="col-md-3">


                <mat-form-field class="full-width">

                    <intelli-selector placeholder="Sorteio" [options]="_rangeOptions"
                        [formControl]="_rangeOptionsControl"> </intelli-selector>
                </mat-form-field>

            </div>
            <div *ngIf="_rangeOptions!=null && _rangeOptions.length > 0"
                class="col-md-{{_rangeOptions.length > 1?'9':'12'}}">

                <div *ngIf="!preSelected;else divPreSelected">
                    <div *ngIf="!_filter"><span class="warning">Selecione um filtro para iniciar a análise</span></div>
                    <mat-form-field class="filter-list">
                        <spolti-data-selector [parts]="_selectedFilterForm" [placeholder]="'Filtro'"
                            [searchFn]="searchLotteryFilters" [displayFn]="displayLotteryName"
                            [getItemByIdFn]="getLotteryFilterById" (idChanged)="onFiltroSelecionado($event)">
                        </spolti-data-selector>
                    </mat-form-field>
                </div>
                <ng-template #divPreSelected>

                    <h2>{{_filter.name}}</h2>
                </ng-template>
            </div>

            <div class="col-md-12">
                <div *ngIf="!_showGraph" class="more-padding">
                    <kt-soft-progress-bar-green prefix="Gerando estatística  "
                        [percentValue]="this._progress"></kt-soft-progress-bar-green>
                </div>
            </div>


        </div>
        <br>
        <div class="row more-padding" *ngIf="_lottery!=null &&  _filter!=null">

            <div class="col-md-6">
                <h6>Configuração do filtro</h6>
                <mat-divider></mat-divider>
                <br>
                <kt-filter-editor [lotteryId]="_lottery.id" [cols]="_lottery.GridNumbersColumns"
                    [rows]="_lottery.GridNumbersRows" [numberList]="_lottery.NumberList"
                    [headerNumberList]="_lottery.headerColsList" [filter]="_filter"
                    (changeParams)="changeFilterValues($event)" [betId]="betId"
                    (savedParams)="savedParams.emit($event)"></kt-filter-editor>

            </div>
            <div class="col-md-6 {{_opacity}}">
                <h6>Soma de resultados dentro da faixa do filtro</h6>
                <mat-divider></mat-divider>
                <div id="charttotaldiv"></div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-12 {{_opacity}}">

                <h6>Ocorrências em relação a natureza do filtro</h6>
                <mat-divider></mat-divider>
                <div id="chartdiv" [style.height]='_graphHeight'></div>
            </div>
        </div>

    </kt-portlet-body>
</kt-portlet>